import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import img from "../../images/thumb-1920-493353.jpg";
import { useEffect, useRef } from "react";

export default function RepresentationsHero({ onVisibilityChange }) {
  const { t } = useTranslation("representations"); // using your representations.json
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => onVisibilityChange?.(entry.isIntersecting),
      { threshold: 0.45 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [onVisibilityChange]);

  return (
    <Box ref={sectionRef}>
      {/* IMAGE HEADER */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "55vh", md: "65vh" },
          backgroundColor: "#0B0B0B",
          overflow: "hidden",
        }}
      >
        {/* IMAGE PLACEHOLDER */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.65)",
          }}
        />

        {/* TITLE OVER IMAGE */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "flex-end",
            px: { xs: 3, md: 8 },
            pb: { xs: 6, md: 12 },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Playfair Display",
              fontSize: { xs: "2rem", md: "5rem" },
              letterSpacing: "0.05em",
              color: "#FFFFFF",
              textTransform: "uppercase",
              fontWeight: 700,
              lineHeight: 1.1,
              textShadow: "2px 2px 12px rgba(0,0,0,0.5)",
            }}
          >
            {t("title")}
          </Typography>
        </Box>
      </Box>

      {/* INTRO COPY */}
      <Box
        sx={{
          maxWidth: 950,
          px: { xs: 3, md: 8 },
          py: { xs: 6, md: 10 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "1.5rem", md: "2rem" },
            fontWeight: 600,
            letterSpacing: "0.03em",
            mb: 3,
            color: "#111111",
          }}
        >
          {t("headline")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.8,
            color: "#4A4A4A",
          }}
        >
          {t("description")}
        </Typography>
      </Box>
    </Box>
  );
}
